module.exports = __webpack_public_path__ + "media/images/countryrect/pk-c83d40c112ebd2215836df72264f29da.svg";